<template>
  <div class="content-container">
    <search-comp
      @onSearch="attachData"
      @onReset="
        () => {
          searchParams.keyword = ''
          attachData()
        }
      "
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Thông tin tìm kiếm</div>
                <div class="child-w-80">
                  <input
                    v-model="searchParams.keyword"
                    type="text"
                    placeholder="Nhập thông tin tên nhóm"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <!-- <el-row :gutter="30" style="margin-bottom: 20px">
      <el-col :lg="8" :md="12" :sm="24" :xs="24"><el-input v-model="searchParams.keyword" placeholder="Nhập thông tin" style="width: 100%" /></el-col>
      <el-col :span="12"> <el-button type="primary" @click="attachData">Tìm kiếm</el-button></el-col>
    </el-row> -->
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :rows="rows"
        class="agGrid"
        :auto-size-cell="true"
        :row-multi-select-with-click="true"
        :auto-select-first-row="false"
        @refresh="onRefresh"
        @selectionChanged="selectionChanged"
      />
      <!-- :is-row-selectable="isRowSelectable" -->
    </div>
    <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="totalPage"
        :page-num="currentPage"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>
    <div class="button-containers mb-0">
      <button
        :disabled="isDisableDelete"
        class="btn primary small outline"
        @click="deleteGroupUser"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        :disabled="isDisableModify"
        class="btn primary small"
        @click="updateGroupUserView"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="addView">
        {{ $t('button.add') }}
      </button>
      <button class="btn primary small" @click="updateViewMenu">
        {{ $t('button.menuAuthorization') }}
      </button>
    </div>

    <el-dialog
      title="Phân quyền Menu"
      :visible.sync="dialogFormVisibleMenu"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Tên nhóm</div>

                  <div class="child-w-80">
                    <input v-model="form.name" disabled type="text" />
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label">Mô tả</div>

                  <textarea
                    v-model="form.desc"
                    style="width: 100%"
                    disabled
                    rows="2"
                  />
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label">Menu</div>
                  <el-tree
                    ref="treeSelect"
                    :key="key"
                    :data="dataMenu"
                    show-checkbox
                    node-key="menu_id"
                    :props="defaultProps"
                  >
                    <!-- :default-checked-keys="[1, 2]" -->
                  </el-tree>
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small"
            @click="dialogFormVisibleMenu = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            class="btn primary small outline"
            @click="updateAuthorizationMenu"
          >
            {{ $t('button.update') }}
          </button>
        </div>
      </span>
    </el-dialog>

    <el-dialog
      :title="!isEdit ? 'Thêm nhóm người dùng' : 'Sửa nhóm người dùng'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Tên nhóm</div>
                  <validation-provider
                    rules="required|max:50"
                    name="Tên nhóm người dùng"
                  >
                    <!-- :disabled="isEdit" -->
                    <div class="child-w-80">
                      <input v-model="form.name" type="text" />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Cấp bậc</div>
                  <validation-provider
                    rules="number|level"
                    name="Cấp bậc người dùng"
                  >
                    <!-- :disabled="isEdit" -->
                    <div class="child-w-80">
                      <input v-model="form.level" type="text" />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label">Mô tả</div>
                  <validation-provider
                    rules="max:255"
                    name="Mô tả nhóm người dùng"
                  >
                    <textarea
                      v-model="form.desc"
                      style="width: 100%"
                      rows="4"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small outline"
            @click="updateGroupUser"
          >
            {{ $t('button.update') }}
          </button>
          <button
            v-else
            class="btn primary small outline"
            @click="addGroupUser"
          >
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */

import {
  getUserGroupApi,
  deleteUserGroupApi,
  updateUserGroupApi,
  addUserGroupApi,
  updateUserGroupMenuApi
} from '@/api/userConfig/userGroup'
import { Message } from 'element-ui'
import {
  getMenuListApi,
  getFullMenuListApi
} from '@/api/auth_service/authManage'
import grid from '@/lang/componentsVi/grid'
export default {
  data() {
    return {
      key: 1,
      loading: false,
      isDisableDelete: true,
      isDisableModify: true,
      defaultProps: {
        children: 'children',
        label: 'title'
      },
      defaultForm: {
        id: null,
        name: '',
        desc: '',
        level: 0,
        notice_receive: false
      },
      form: {
        id: null,
        name: '',
        desc: '',
        level: 0,
        notice_receive: false
      },
      titlePopup: 'Thêm nhóm người dùng',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      dialogFormVisibleMenu: false,
      searchParams: {
        pageSize: 10,
        pageNum: 1,
        keyword: ''
      },
      dataMenu: [],
      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: this.$t('grid.column.groupName'),
          field: 'name',
          sortable: false,
          width: 100
        },
        {
          headerName: 'Cấp bậc',
          field: 'level',
          sortable: false,
          maxWidth: 200,
          minWidth: 100
        },
        {
          headerName: this.$t('grid.column.desc'),
          sortable: false,
          field: 'desc'
          // cellRenderer: 'CellRenderTextInput',
        }
      ],
      rows: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetForm()
    },
    dialogFormVisibleMenu(newval) {
      if (newval) {
        this.key = this.key + 1
        this.$nextTick(() => {
          const treeInstance = this.$refs.treeSelect
          if (treeInstance) {
            this.form.menu_ids.map(item => {
              treeInstance.setChecked(item, true, false) // Thay [1, 2, 3] bằng keys bạn muốn set
            })
          }
        })
      }
    }
  },

  mounted() {
    this.attachData()
  },
  created() {
    this.getMenuList()
  },
  methods: {
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    async onPageChanged(pageNum) {
      this.searchParams.pageNum = pageNum
      await this.attachData()
    },
    async onPageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.searchParams.pageNum = 1
      await this.attachData()
    },
    selectionChanged(rows) {
      let flag = 0
      rows.forEach(row => {
        if (row.deletable == false) {
          flag = 1
          return
        }
      })
      if (flag || rows.length == 0) this.isDisableDelete = true
      else this.isDisableDelete = false
      if (rows.length > 1 || rows.length == 0) this.isDisableModify = true
      else this.isDisableModify = false
    },

    // recursive
    getMenuData(obj) {
      // Base case: if the object is not an array or an object, return it as is
      if (!obj || typeof obj !== 'object') {
        return obj
      }
      // If the object is an array, iterate over its elements
      if (Array.isArray(obj)) {
        return obj.map(item => this.getMenuData(item))
      }
      // If the object is an object, iterate over its key-value pairs
      // obj.title = obj.title ? this.$t('route.' + obj.title) : null
      const newObj = {}
      for (const key in obj) {
        if (key === 'title') {
          newObj[key] = this.$t('route.' + obj[key])
        } else {
          newObj[key] = obj[key]
        }
        if (obj.children) {
          newObj.children = this.getMenuData(obj.children)
        }
      }
      return newObj
    },

    async getMenuList() {
      await getFullMenuListApi()
        .then(res => {
          this.dataMenu = this.getMenuData(res.data)
        })
        .catch(() => {})
    },
    async attachData() {
      this.searchParams.keyword = this.searchParams.keyword.trim()
      this.loading = true
      let data = await getUserGroupApi(this.searchParams)
      this.loading = false
      this.rows = data.data
      this.totalPage = Math.ceil(data.total / this.searchParams.pageSize)
      this.currentPage = data.data.length == 0 ? 0 : this.searchParams.pageNum
    },
    async addGroupUser() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      await addUserGroupApi(this.form)
        .then(data => {
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + data.message)
          })
          this.attachData()
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
      // this.dialogFormVisible = false
      // this.$message({
      //   type: 'success',
      //   message: 'Bạn đã thêm nhóm người dùng thành công'
      // })
      // this.attachData()
    },
    async updateGroupUser() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return

      await updateUserGroupApi(this.form)
        .then(data => {
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + data.message)
          })
          this.attachData()
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
      // this.dialogFormVisible = false
      // this.$message({
      //   type: 'success',
      //   message: 'Bạn đã cập nhật nhóm người dùng thành công'
      // })
      // this.attachData()
    },

    deleteGroupUser() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      if (id_list.length == 0) {
        this.$vxAlert('Bạn chưa chọn nhóm người dùng!', 'Error', {
          confirmButtonText: 'OK'
        })
      } else {
        this.$vxConfirm(
          'Bạn chắc chắn muốn xoá nhóm người dùng này?',
          async () => {
            await deleteUserGroupApi(id_list)
              .then(data => {
                this.$message({
                  type: 'success',
                  message: this.$t('successMsg.' + data.message)
                })
                this.attachData()
              })
              .catch(error => {
                let errDeleleList = error?.response?.data?.error_list
                let errNameList = errDeleleList.map(it => it.name)
                this.$message({
                  type: 'error',
                  message:
                    errNameList.join(', ') +
                    ' ' +
                    this.$t('errorMsg.' + error.response.data.message)
                })
                this.dialogFormVisible = false
              })
              .finally()
          }
        )
      }
    },
    async updateAuthorizationMenu() {
      const selectedMenuParent = this.$refs.treeSelect.getHalfCheckedKeys()
      const selectedMenuChild = this.$refs.treeSelect.getCheckedKeys()
      const menu_ids = selectedMenuParent.concat(selectedMenuChild)

      await updateUserGroupMenuApi({ userGroupId: this.form.id }, menu_ids)
        .then(data => {
          if (!data.is_error) {
            // this.rows = data.data
            this.$message({
              type: 'success',
              message: 'Bạn đã cập nhật thành công'
            })
            this.attachData()
            this.dialogFormVisibleMenu = false
          } else {
            throw new Error(data)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {})
    },

    addView() {
      this.dialogFormVisible = true
      this.isEdit = false
    },
    updateGroupUserView() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      if (rowsSelected.length == 0 || rowsSelected.length > 1) {
        this.$vxAlert('Bạn vui lòng chọn 1 nhóm người dùng để sửa')
      } else {
        this.titlePopup = 'Sửa nhóm người dùng'
        this.isEdit = true
        const rowData = rowsSelected[0]
        this.form = { ...rowData }
        this.dialogFormVisible = true
      }
    },

    updateViewMenu() {
      //
      const gridApi = this.$refs.agGrid.gridApi
      // const treeInstance = this.$refs.treeSelect
      const rowsSelected = gridApi.getSelectedRows()
      if (rowsSelected.length == 0 || rowsSelected.length > 1) {
        this.$vxAlert('Bạn vui lòng chọn 1 nhóm người dùng')
      } else {
        const rowData = rowsSelected[0]
        this.form = { ...rowData }
        this.dialogFormVisibleMenu = true
        // treeInstance.setCheckedKeys(rowData.menu_ids)
      }
    },
    resetForm() {
      this.form = { ...this.defaultForm }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
